<template>
  <li class="list-item">
    <!-- 时间日期，介绍，签字/查看按钮 -->
    <div>
      <div class="flex-right">
        <span>{{item.createTimes}}</span>
        <p class="textnum">{{ item.classId }}</p>
        <router-link :to="`/signature/${item.id}/${item.signStatus}/false`">
          <template v-if="item.signStatus=='1'">
              <span @click="look(item.id,item.signStatus,item.status,item.createTimes)">查看></span>
          </template>
          <template v-else>
              <span @click="look(item.id,item.signStatus,item.status,item.createTimes)" style="color:#13ce66;">签字></span>
          </template>
        </router-link>
      </div>
    </div>
  </li>
</template>

<script>
  import MyClass from '../api/myclass';
  export default{
    name: 'news-item',
    props: {
      item: {
        type: Object
      }
    },
    data () {
      return {
      };
    },
    methods: {
      //单机查看掉接口，进行查询存储的签过字的图片回显
      look(id,signStatus,status,createTimes){
        MyClass.getSignatureImage({id,signStatus,status,createTimes}).then(response=>{
            //获取当前点击查看的签字信息
            this.$store.commit('SelectSignature',response.data);
        })
        .catch(e => {
          console.log(e)
        });
      },
      // handleClick({payload}) {
      //   // 触发父组件 方法
      //   this.$store.commit('setImgInfo', payload);
      //   this.$router.push({path: '/picture-view'});
      // }
    },
    // computed: {
    //   dayOfMonth () {
    //     let day = new Date(this.item.created_at * 1000).getDate();
    //     if (day <= 9) {
    //       return `0${day}`;
    //     } else {
    //       return day;
    //     }
    //   },
    //   monthOfYear () {
    //     let month = new Date(this.item.created_at * 1000).getMonth() + 1;
    //     if (month <= 9) {
    //       return `0${month}月`;
    //     } else {
    //       return `${month}月`;
    //     }
    //   }
    // }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .list-item {
    padding: px2rem(25) 0 0 0;
    
    &:after {
      content: "";
      display: block;
      margin-top: px2rem(10);
      border-bottom: 1px solid #cba164;
      border-radius: px2rem(20);
    }
    .flex-right{
      display: flex;
      justify-content: space-around;
      // .textnum{
      //   width: px2rem(250); /* 设置固定宽度 */
      //   border: 1px solid red;
      //   white-space: nowrap; /* 防止文字换行 */
      //   overflow: hidden; /* 超出部分隐藏 */
      //   text-overflow: ellipsis; /* 使用省略号代替超出部分 */
      // }
    }

    // .min_height {
    //   min-height: px2rem(160);
    // }

    // .user-wrapper {
    //   font-size: 0;
    //   display: flex;
    //   flex-direction: row;
    //   .avatar {
    //     margin-right: px2rem(14);
    //     height: px2rem(95);
    //     width: px2rem(95);
    //     border-radius: 50%;
    //     border: px2rem(1) solid white;
    //     vertical-align: bottom;
    //   }

    //   .user-info {
    //     flex: 1;
    //     display: inline-block;
    //     color: rgb(58, 35, 10);
    //     margin-top: px2rem(10);
    //     .username {
    //       font-size: px2rem(24);
    //       height: px2rem(40);
    //       font-weight: 600;
    //       line-height: px2rem(40);
    //     }
    //     .desc {
    //       font-size: px2rem(22);
    //       line-height: px2rem(40);
    //     }
    //   }
    // }
    // .img-wrapper {
    //   display: flex;
    //   .timer {
    //     width: px2rem(100);
    //     position: relative;
    //     display: inline-block;
    //     font-size: 0;
    //     span {
    //       position: absolute;
    //       bottom: px2rem(5);
    //       color: #3a230a;
    //       vertical-align: bottom;
    //       display: inline-block;
    //       &:nth-child(1) {
    //         height: px2rem(36);
    //         line-height: px2rem(36);
    //         font-size: px2rem(36);
    //       }
    //       &:nth-child(2) {
    //         box-sizing: border-box;
    //         height: px2rem(36);
    //         padding-top: px2rem(2);
    //         line-height: px2rem(36);
    //         font-size: px2rem(20);
    //         left: px2rem(45);
    //       }
    //     }
    //   }
    //   .imgs {
    //     display: inline-block;
    //     flex: 1;
    //     font-size: 0;
    //     img {
    //       margin: px2rem(4) px2rem(4);
    //       height: px2rem(145);
    //       width: px2rem(145);
    //     }
    //   }
    // }
  }
</style>



// WEBPACK FOOTER //
// NewsItem.vue?3d2d9ed6